var s = /* @__PURE__ */ ((e) => (e.DEFAULT = "default-state", e.PROCESSING = "processing", e.SUCCESS = "success", e.DISABLED = "disabled", e))(s || {});
export {
  s as BUTTON_STATE
};
//# sourceMappingURL=button-state.js.map
